export default  {
    apiKey: "AIzaSyAIalCRbWnXMtQoIpTURVDSRn_H0s--e_E",
    authDomain: "zharco-223213.firebaseapp.com",
    databaseURL: "https://zharco-223213.firebaseio.com",
    projectId: "zharco-223213",
    storageBucket: "zharco-223213.appspot.com",
    messagingSenderId: "536358434892",
    appId: "1:536358434892:web:8889e49ff92de631eedce9",
    measurementId: "G-YPDH08M4XM"
  };